<mat-card class="cardSection">
    <p class="headline6"> {{'settings.title' | translate}} </p>
    <p 
        class="body3Medium pointer" 
        (click)="toggleOption(1)"> 
            {{'settings.options.one' | translate}}  
            <mat-icon class="blackIcon">chevron_right</mat-icon>
    </p>
</mat-card>
